import { mensagemDe } from "@mtc/ui";
import { useCallback, useState } from "react";
import { useSessao } from "./sessao";

/** Chamadas da area com corpo JSON (POST sem corpo leva "{}": o backend recusa JSON vazio). */
export function useApi() {
  const { api, enviar } = useSessao();
  return {
    ler: <T,>(caminho: string) => api<T>(caminho),
    postar: <T,>(caminho: string, corpo: unknown = {}) => api<T>(caminho, { method: "POST", body: JSON.stringify(corpo) }),
    por: <T,>(caminho: string, corpo: unknown) => api<T>(caminho, { method: "PUT", body: JSON.stringify(corpo) }),
    // Desistir do pedido de repasse (spec 031, 3.4): o cliente tira da fila o que ninguem decidiu ainda.
    apagar: <T,>(caminho: string) => api<T>(caminho, { method: "DELETE" }),
    enviar,
  };
}

/** Uma acao da tela: carregando, erro legivel (a mensagem do backend) e `rodar`, que devolve se deu certo. */
export function useAcao() {
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<string>();
  const rodar = useCallback(async (f: () => Promise<unknown>): Promise<boolean> => {
    setCarregando(true);
    setErro(undefined);
    try {
      await f();
      return true;
    } catch (err) {
      setErro(mensagemDe(err, "Não deu certo agora. Tente de novo em instantes."));
      return false;
    } finally {
      setCarregando(false);
    }
  }, []);
  return { carregando, erro, rodar, limpar: () => setErro(undefined) };
}
